<template>
    <div class="estimate-summary-data">
        <div class="ah-statistics-bar" style="border-bottom: 0px; margin-top: 15px">
            <div class="item">
                <div class="inner">
                    <div class="label">{{ year }} 年度預估營業總收入（100%）</div>
                    <div class="value">
                        <Money :v="totalIncome" round />
                    </div>
                </div>
                <div class="operator">-</div>
                <div class="inner">
                    <div class="label">{{ year }} 年度預估營業總支出（{{ getPercentage(totalPayout) }}%）</div>
                    <div class="value">
                        <Money :v="totalPayout" round />
                    </div>
                </div>
                <div class="operator">=</div>
                <div class="inner">
                    <div class="label">{{ year }} 年度預估營業淨收（{{ getPercentage(netIncome) }}%）</div>
                    <div class="value">
                        <Money :v="netIncome" round />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        year: Number,
        totalIncome: Number,
        totalPayout: Number,
    },
    computed: {
        netIncome() {
            return Math.round(this.totalIncome) - Math.round(this.totalPayout);
        },
    },
    methods: {
        getPercentage(value) {
            return Math.round((value / this.totalIncome) * 10000) / 100;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.estimate-summary-data {
    margin-top: 20px;
    text-align: center;
    padding: 20px 0 0px 0;

    .ah-statistics-bar {
        .label {
            color: $main-color;
            font-weight: bold;
        }
        .value {
            color: #666;
        }
    }

    .company-name {
        font-size: 12pt;
        @media print {
            font-size: 11pt;
        }
    }
    .doc-name {
        font-size: 13pt;
        font-weight: bold;
        margin: 3px 0;

        @media print {
            margin: 2px 0;
            font-size: 11pt;
        }
    }
    .date {
        font-size: 10pt;
        @media print {
            font-size: 9pt;
        }
    }

    .item {
        display: flex;
    }
    .operator {
        display: flex;
        align-items: center;
        margin: 0 50px;
        font-size: 40px;
        color: #b9b9b9;
    }

    @media print {
        margin-top: 0;
        border-top: 0;
        padding: 0;
        .label {
            font-size: 5pt;
        }
        .value {
            font-size: 13pt;
        }

        .operator {
            margin: 0 10px;
            font-size: 30px;
        }
    }
}
</style>
